webpackJsonp([12],{

/***/ "G6FJ":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "jtC0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });

// EXTERNAL MODULE: ./static/js/map.js
var map = __webpack_require__("oICd");

// CONCATENATED MODULE: ./node_modules/_babel-loader@7.1.5@babel-loader/lib!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=script&index=0!./src/components/contactUs/contactUs.vue
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

//引入底部子组件

// import Banner from '../layout/banner'
/* harmony default export */ var contactUs = ({
  metaInfo: {
    title: '英特之家--金成英特教育', // set a title
    meta: [{ // set meta
      name: '英特之家--金成英特教育'
    }]
  },
  name: 'contactUs',
  props: [],
  data: function data() {
    return {
      ak: 'NsXKtvGd5DzXDR7thVIifGLqWP5wLX84',
      content: {}
    };
  },
  created: function created() {},

  inject: ['reload'],
  mounted: function mounted() {
    //type发生改变，向父组件传参
    if (this.$route.query.type) {
      this.$emit('typeChange', this.$route.query.type);
    }
    this.$nextTick(function () {
      var _this = this;
      Object(map["a" /* MP */])(_this.ak).then(function (BMap) {
        //在此调用api
        _this.initMap();
      });
    });
    //获取公司信息
    getValue(this);
  },


  methods: {
    initMap: function initMap() {
      //    以上是公共部分
      var map = new BMap.Map('allmap');
      var point = new BMap.Point(120.145734, 30.275245);
      map.centerAndZoom(point, 19);
      var marker = new BMap.Marker(point); // 创建标注
      map.addOverlay(marker); // 将标注添加到地图中;
      map.enableScrollWheelZoom(true);
      var polygon_nc = new BMap.Polygon([new BMap.Point(120.145244, 30.275316), new BMap.Point(120.146048, 30.275358), new BMap.Point(120.14625, 30.2753), new BMap.Point(120.146461, 30.274918), new BMap.Point(120.145339, 30.27484), new BMap.Point(120.145316, 30.274848), new BMap.Point(120.14524, 30.2753)], { strokeColor: "#6ba9e5", fillColor: "#c7dff0", strokeStyle: "solid", strokeOpacity: "0.8", fillOpacity: "0.3", strokeWeight: "3" });
      map.addOverlay(polygon_nc);
    }
  }
});
function getValue(obj) {
  obj.$ajax('companyInfo/getCompanyInfo', 'get', {}, function (res) {
    var objData = res.data;
    obj.content = res.data;
    obj.$t('contactUs.contactUs')[0].value = objData.hotLine;
    obj.$t('contactUs.contactUs')[1].value = objData.email;
    obj.$t('contactUs.contactUs')[2].value = objData.weChat;
    // obj.$t(`contactUs.contactUs`)[3].value = objData.weChat;
  });
}
// CONCATENATED MODULE: ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-7da79ac0","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/contactUs/contactUs.vue
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contactUs"},[_c('div',{staticClass:"contact_title"},[_vm._v(_vm._s(_vm.$t("contactUs.contactUsTitle")))]),_vm._v(" "),_c('div',{staticClass:"content"},[_c('ul',{staticClass:"contentUl"},_vm._l((_vm.$t("contactUs.contactUs")),function(item,index){return _c('li',{key:index,staticClass:"contentLi"},[_c('div',{staticClass:"content_img",style:('background: url('+item.url+') center no-repeat')}),_vm._v(" "),_c('div',{staticClass:"content_style"},[_c('div',{staticClass:"content_name"},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('div',{staticClass:"content_value"},[_vm._v(_vm._s(item.value))])]),_vm._v(" "),_c('div',{staticClass:"erweima"})])}),0)]),_vm._v(" "),_c('div',{staticClass:"address"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"map_right"},[_c('div',{staticClass:"right_warpper"},[_c('div',{staticClass:"map_top"},[_c('i',{staticClass:"icon"}),_vm._v(" "),_c('div',{staticClass:"map_title"},[_vm._v(_vm._s(_vm.$t("contactUs.mapAddressTitle")))])]),_vm._v(" "),_c('div',{staticClass:"map_bottom"},[_c('div',{staticClass:"bottom_title"},[_vm._v(_vm._s(_vm.$t("contactUs.map_address")))]),_vm._v(" "),_c('div',{staticClass:"bottom_address"},[_vm._v(_vm._s(_vm.content.address))])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"map_left"},[_c('div',{attrs:{"id":"allmap"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ var contactUs_contactUs = (esExports);
// CONCATENATED MODULE: ./src/components/contactUs/contactUs.vue
function injectStyle (ssrContext) {
  __webpack_require__("G6FJ")
}
var normalizeComponent = __webpack_require__("C7Lr")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7da79ac0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  contactUs,
  contactUs_contactUs,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ var components_contactUs_contactUs = __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "oICd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = MP;
function MP(ak) {
  return new Promise(function (resolve, reject) {
    window.init = function () {
      resolve(BMap)
    }
    var script = document.createElement("script");
    script.type = "text/javascript";
    script.src = "//api.map.baidu.com/api?v=2.0&ak=" + ak + "&callback=init";
    script.onerror = reject;
    document.head.appendChild(script);
    // script.onload = function () {
    //   resolve(BMap)
    // }
  })
}


/***/ })

});


// WEBPACK FOOTER //
// static/js/12.86b62318be70249c70fe.js